var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export default (function (_a) {
    var className = _a.className, htmlAttributes = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", className: className }, htmlAttributes),
        React.createElement("path", { d: "M21,21 L21,19 C21,16.2385763 18.7614238,14 16,14 L7.99999996,14 C5.23857622,14 2.99999996,16.2385763 2.99999996,19 L2.99999996,21 C2.99999996,21.5522848 3.44771521,22 3.99999996,22 C4.55228472,22 4.99999996,21.5522848 4.99999996,21 L4.99999996,19 C4.99999996,17.3431458 6.34314573,16 7.99999996,16 L16,16 C17.6568543,16 19,17.3431458 19,19 L19,21 C19,21.5522848 19.4477153,22 20,22 C20.5522848,22 21,21.5522848 21,21 Z M12,12 C14.7614238,12 17,9.76142374 17,6.99999996 C17,4.23857622 14.7614238,1.99999996 12,1.99999996 C9.23857624,1.99999996 6.99999998,4.23857622 6.99999998,6.99999996 C6.99999998,9.76142374 9.23857624,12 12,12 Z M12,9.99999997 C10.3431457,9.99999997 8.99999999,8.65685424 8.99999999,6.99999997 C8.99999999,5.34314572 10.3431457,3.99999997 12,3.99999997 C13.6568543,3.99999997 15,5.34314572 15,6.99999997 C15,8.65685424 13.6568543,9.99999997 12,9.99999997 Z" })));
});
